module.exports = __webpack_public_path__ + "media/martyparty.28b7ff50.mp4";